import styled, { css } from 'styled-components';
import { Flex, Icon, Text } from 'ui';
import { Button } from 'components/Button/Button';
import { useMutationLogout } from 'graphql/mutation';

export const RestrictedAccess = () => {
  const [logout, { loading }] = useMutationLogout();

  const handleLogout = () => {
    logout({ refetchQueries: ['user'] });
  };

  return (
    <Wrapper>
      <MessageBox flexDirection="column" alignItems="center">
        <IconWrapper mb="s30">
          <Icon name="16-alert-solid" color="warning50" />
        </IconWrapper>
        <Text
          fontSize="fs400"
          fontWeight="bold"
          lineHeight="lh400"
          mb="s20"
          textAlign="center"
        >
          Access restricted
        </Text>
        <Text lineHeight="lh300" mb="s10" textAlign="center">
          Your account is currently not linked to any business partner, so
          access to the portal is limited.
        </Text>
        <Text lineHeight="lh300" mb="s40" textAlign="center">
          Please contact your sales representative to restore access.
        </Text>
        <Button variant="primary" onClick={handleLogout} loading={loading}>
          Log out
        </Button>
      </MessageBox>
    </Wrapper>
  );
};

const Wrapper = styled(Flex)`
  min-height: 100vh;
  justify-content: center;
  align-items: center;
  background: #e3edf6;
`;

const IconWrapper = styled(Flex)`
  svg {
    width: 48px;
    height: 48px;
  }
`;

const MessageBox = styled(Flex)`
  ${({ theme: { space, colors } }) => css`
    max-width: 480px;
    padding: ${space.s60} ${space.s50};
    background: ${colors.white};
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08);
  `}
`;
